export class Errors {
  errors: { [key: string]: string } = {};
  message: { [key: string]: string } = null;
  error: { [key: string]: string } = null;
}
